import { Accordion, Container, Image } from "react-bootstrap";
import "../../../../assets/scss/components/sections/home/faq.scss";
import { useState } from "react";

import data from "./faq_data.json";

import openIcon from "../../../../assets/images/home/open.svg";
import closeIcon from "../../../../assets/images/home/closeIcon.svg";
import Heading from "../../../templates/heading";
import Btn from "../../../templates/button";

const FAQ = () => {
  const [activeKey, setActiveKey] = useState(null);

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="faq-section" id="faq">
      <Container>
        <div className="faq">
          <Heading
            heading="Frequently Asked Questions"
            text="Find answers to common questions about how Resumly works and how it can help you succeed"
          />
          <div className="faq-boxes">
            {data.faqs.map((d, index) => (
              <div className="faq-box" key={index}>
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header onClick={() => handleToggle(index)}>
                      {d.question}
                      <div className="toggleIcon">
                        <Image
                          src={activeKey === index ? closeIcon : openIcon}
                        />
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="paragraph-samll-regular">
                      {d.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Btn
              text="Get Started"
              class="btn-secondary"
              handle={() => {
                window.location.href = process.env.REACT_APP_APP_REGISTER_URL;
              }}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FAQ;
